import clsx from 'clsx';

import classes from './schedule.module.css';

const ScheduleSideBar = () => {
  return (
    <div className={clsx(classes.pane, classes.left)}>
      <div className={classes.subNavHeader}>Schedule</div>
    </div>
  );
};

export default ScheduleSideBar;
